export default "__VITE_ASSET__BM4AvE3h__"